import { ReactElement } from 'react';
import { Typography } from 'antd';

const { Title: AntTitle, Paragraph } = Typography;

const Title = (): ReactElement => {
  return (
    <>
      <AntTitle level={1}>架電依頼</AntTitle>
      <Paragraph type='secondary'>RPMの応募者IDを入力して架電を依頼できます。</Paragraph>
    </>
  );
};

export default Title;
